import { push } from 'connected-react-router'
import { CALL_API } from '../../util/RBRestMiddleware'

// Close snack bar

export const CLOSE_SNACK = 'CLOSE_SNACK'

export const closeSnackBar = () => {
  return {
    type: CLOSE_SNACK
  }
}

// Reset stepindex
export const RESET_INDEX = 'RESET_INDEX'

export const resetStepIndex = () => {
  return {
    type: RESET_INDEX
  }
}

// Reset stepindex
export const PULL_INDEX = 'PULL_INDEX'

export const pullStepIndex = () => {
  return {
    type: PULL_INDEX
  }
}

// ACTIONS FOR STEPPER: handle back and next buttons

export const HANDLE_NEXT = 'HANDLE_NEXT'
export const handleNext = () => {
  return {
    type: HANDLE_NEXT
  }
}

export const HANDLE_PREV = 'HANDLE_PREV'
export const handlePrev = () => {
  return {
    type: HANDLE_PREV
  }
}

// making a call to API
export const ACTIVATE_QUESTIONS_LOADING = 'ACTIVATE_QUESTIONS_LOADING'
export const ACTIVATE_QUESTIONS_SUCCESS = 'ACTIVATE_QUESTIONS_SUCCESS'
export const ACTIVATE_QUESTIONS_FAILED = 'ACTIVATE_QUESTIONS_FAILED'

export const fetchSecurityQuestions = () => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: '/account/getSecurityQuestions',
        prefix: 'ACTIVATE_QUESTIONS'
      }
    })
  }
}

// SEND USER INPUTS FROM STEP 2
export const ACTIVATE_SEND_LOADING = 'ACTIVATE_SEND_LOADING'
export const ACTIVATE_SEND_SUCCESS = 'ACTIVATE_SEND_SUCCESS'
export const ACTIVATE_SEND_FAILED = 'ACTIVATE_SEND_FAILED'

export const postAccountInfo = (activationInfo) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: '/account/activateAccount',
        method: 'post',
        prefix: 'ACTIVATE_SEND',
        query: activationInfo,
        onSuccess: () => {
          dispatch(handleNext())
        }
      }
    })
  }
}

// ACCEPT CONDITIONS AND COMPLETE ACTIVATION
export const ACTIVATION_LOADING = 'ACTIVATION_LOADING'
export const ACTIVATION_SUCCESS = 'ACTIVATION_SUCCESS'
export const ACTIVATION_FAILED = 'ACTIVATION_FAILED'

// calls api to complete activation, passes activateInfo here as well
export const completeActivation = (activationInfo) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: '/account/completeActivation',
        method: 'post',
        prefix: 'ACTIVATION',
        query: activationInfo,
        onSuccess: () => {
          dispatch(push('/ActivationComplete'))
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/activateActions.js